import SseHub from './SseHub.js';

// Cliente SSE para la narración del progreso de la generación de resúmenes de calendario.
// Singleton de módulo: la conexión sobrevive a que se cierre el modal y a la navegación, así que
// el usuario sigue viendo cómo va (y cuánto queda) y recibe aviso al terminar esté donde esté.

const subscribers = [];
let enganchado = false;
const CANAL = 'listado-calendario';
let f7ref = null;
let ultimoEvento = null;

function notify(payload) {
    subscribers.slice().forEach(function (cb) {
        try { cb(payload); } catch (err) { console.error('ListadoCalendarioEvents subscriber threw', err); }
    });
}

function toastGlobal(texto) {
    try {
        if (f7ref && f7ref.toast) {
            f7ref.toast.create({ text: texto, closeTimeout: 6000, closeButton: true }).open();
        }
    } catch (e) {}
}

function cerrarStream() {
    // La conexión es única y compartida por todos los canales: aquí solo nos desenganchamos.
    if (enganchado) {
        SseHub.unsubscribe(CANAL, onEvento);
        enganchado = false;
    }
    // Y olvidamos el último evento. Si no, el subscribe() de la siguiente tirada reproduce
    // el evento terminal de la anterior, quien lo reciba lo toma por final de la nueva y
    // vuelve a cerrar el stream recién abierto: la generación corre pero sin narración.
    ultimoEvento = null;
}

function onEvento(evento) {
    // El hub entrega el payload ya deserializado (antes llegaba el evento SSE crudo). Se
    // admite tambien una cadena por si algun emisor mandara texto plano.
    let payload = evento;
    if (typeof evento === 'string') {
        try { payload = JSON.parse(evento); } catch (err) { payload = evento; }
    }
    ultimoEvento = payload;
    const terminado = !!payload && (payload.estado === 'fin' || payload.estado === 'cancelado' || payload.estado === 'error');
    if (payload && payload.estado === 'fin') {
        toastGlobal('✅ ' + (payload.texto || 'Resúmenes generados.'));
    } else if (payload && payload.estado === 'cancelado') {
        toastGlobal('⏹️ ' + (payload.texto || 'Generación cancelada.'));
    } else if (payload && payload.estado === 'error') {
        toastGlobal('⚠️ ' + (payload.texto || 'Error generando los resúmenes.'));
    }
    notify(payload);
    // El ciclo de vida del stream se decide AQUÍ, no en el componente: si el usuario se fue de
    // la pantalla a mitad de job no queda nadie para cerrarlo y la conexión se quedaba colgada
    // hasta el timeout de 30 min.
    if (terminado) {
        cerrarStream();
    }
}

function ensureConnected() {
    if (enganchado) return;
    enganchado = true;
    // Ya no se abre una conexion propia: el hub trae TODOS los canales por un unico stream
    // (el navegador solo admite ~6 por origen en HTTP/1.1 y la app tiene 8 canales).
    SseHub.subscribe(CANAL, onEvento);
}

export default {
    subscribe(callback, f7) {
        if (f7) f7ref = f7;
        if (typeof callback === 'function' && subscribers.indexOf(callback) < 0) {
            subscribers.push(callback);
        }
        ensureConnected();
        // Quien llega tarde recupera el hilo con el último evento conocido; el servidor además
        // reenvía su lastEvent al suscribirse.
        if (ultimoEvento && typeof callback === 'function') {
            try { callback(ultimoEvento); } catch (e) {}
        }
    },
    unsubscribe(callback) {
        const i = subscribers.indexOf(callback);
        if (i >= 0) subscribers.splice(i, 1);
    },
    // El stream se mantiene vivo aunque nadie escuche (así se avisa al terminar aunque se haya
    // cerrado el modal) y se suelta solo al llegar el evento terminal, en onEvento.
    close: cerrarStream,
    ultimoEvento() { return ultimoEvento; }
};
